/**
 * @generated SignedSource<<030e94de9041221e8ea0cb91686dcee6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CourseVisibility = "MEMBER_ONLY" | "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
export type routesInitialPageQuery$variables = {
  slug: string;
};
export type routesInitialPageQuery$data = {
  readonly club: {
    readonly communityEnabled: string | null | undefined;
    readonly configuration: string | null | undefined;
    readonly coursePage: {
      readonly categories: ReadonlyArray<{
        readonly courses: ReadonlyArray<{
          readonly canView: boolean;
          readonly visibility: CourseVisibility;
        }>;
      }>;
      readonly id: string;
    };
    readonly coursesEnabled: string | null | undefined;
    readonly events: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly eventsEnabled: string | null | undefined;
    readonly groups: ReadonlyArray<{
      readonly spaces: ReadonlyArray<{
        readonly isMember: boolean;
        readonly visibility: SpaceVisibility;
      }>;
    }>;
    readonly rankingEnabled: string | null | undefined;
  };
};
export type routesInitialPageQuery = {
  response: routesInitialPageQuery$data;
  variables: routesInitialPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "INITIAL_PAGE"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"INITIAL_PAGE\")"
},
v3 = {
  "alias": "communityEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COMMUNITY_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
},
v4 = {
  "alias": "coursesEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COURSES_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COURSES_ENABLED\")"
},
v5 = {
  "alias": "eventsEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "EVENTS_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"EVENTS_ENABLED\")"
},
v6 = {
  "alias": "rankingEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "LEADERBOARD"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": "CHRONOLOGICAL"
    }
  ],
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v7/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "events(orderBy:\"CHRONOLOGICAL\")"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMember",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canView",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routesInitialPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "CourseCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "courses",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": "courses(status:\"ACTIVE\")"
                  }
                ],
                "storageKey": "categories(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routesInitialPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "CourseCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v11/*: any*/),
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "courses",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v12/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": "courses(status:\"ACTIVE\")"
                  },
                  (v7/*: any*/)
                ],
                "storageKey": "categories(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e447f5488f4cfe5b824df48316bc657",
    "id": null,
    "metadata": {},
    "name": "routesInitialPageQuery",
    "operationKind": "query",
    "text": "query routesInitialPageQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"INITIAL_PAGE\")\n    communityEnabled: configuration(key: \"COMMUNITY_ENABLED\")\n    coursesEnabled: configuration(key: \"COURSES_ENABLED\")\n    eventsEnabled: configuration(key: \"EVENTS_ENABLED\")\n    rankingEnabled: configuration(key: \"LEADERBOARD\")\n    events(orderBy: CHRONOLOGICAL) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    groups {\n      spaces {\n        __typename\n        isMember\n        visibility\n        id\n      }\n      id\n    }\n    coursePage {\n      id\n      categories(status: ACTIVE) {\n        courses(status: ACTIVE) {\n          visibility\n          canView\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c254e792d38788d73ba4d6a69fb01780";

export default node;
